<template>
  <div class="level-img-wrap">
    <b-img :src="require('@/assets/level_t.jpg')" class="level-img" />
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  components: {
    BImg
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>
.level-img-wrap {
  width: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
}
.level-img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>
